import requests from './request2';

import Qs from 'qs';

import { getCookie } from '@/utils/mycookie';
// 用户登录
export const listBook = (d) => requests({ url: '/pdf/list', method: 'post', headers: { 'x-sid': JSON.parse(getCookie('user-inf'))?.user?.uar?.sid, 'x-codic': getCookie('x-myweb-key'), 'Content-Type': 'application/x-www-form-urlencoded' }, data: Qs.stringify(d, { indices: false }) });
